import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "enterInAppBrowser" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "overlay" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}